import { format, parse, isValid } from "date-fns";
import { el } from "date-fns/locale";
import { useEffect, useState } from "react";
import { CalendarBlank } from "@phosphor-icons/react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverAnchor, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

// Typed input (ηη/μμ/εεεε) + optional calendar picker. Stores ISO yyyy-MM-dd.
export function DateField({ value, onChange, placeholder = "ηη/μμ/εεεε", testId, disabled = false }) {
  const [open, setOpen] = useState(false);
  const selected = value ? parse(value, "yyyy-MM-dd", new Date()) : undefined;
  const [text, setText] = useState(selected && isValid(selected) ? format(selected, "dd/MM/yyyy") : "");

  useEffect(() => {
    const d = value ? parse(value, "yyyy-MM-dd", new Date()) : null;
    setText(d && isValid(d) ? format(d, "dd/MM/yyyy") : "");
  }, [value]);

  const handleType = (raw) => {
    const digits = raw.replace(/\D/g, "").slice(0, 8);
    let out = digits;
    if (digits.length > 4) out = `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`;
    else if (digits.length > 2) out = `${digits.slice(0, 2)}/${digits.slice(2)}`;
    setText(out);
    if (digits.length === 8) {
      const d = parse(out, "dd/MM/yyyy", new Date());
      if (isValid(d)) onChange(format(d, "yyyy-MM-dd"));
    } else if (digits.length === 0) {
      onChange("");
    }
  };

  return (
    <Popover open={open} onOpenChange={setOpen} modal>
      <PopoverAnchor asChild>
        <div className="mt-1 flex items-center gap-1">
          <Input
            value={text}
            onChange={(e) => handleType(e.target.value)}
            onBlur={() => {
              const d = parse(text, "dd/MM/yyyy", new Date());
              if (text && isValid(d)) onChange(format(d, "yyyy-MM-dd"));
              else if (!text) onChange("");
              else setText(selected && isValid(selected) ? format(selected, "dd/MM/yyyy") : "");
            }}
            placeholder={placeholder}
            disabled={disabled}
            inputMode="numeric"
            className="rounded-sm tabular-nums"
            data-testid={testId}
          />
          <PopoverTrigger asChild>
            <Button
              type="button"
              variant="outline"
              size="icon"
              disabled={disabled}
              className="shrink-0 rounded-sm"
              data-testid={testId ? `${testId}-picker` : undefined}
              aria-label="Επιλογή από ημερολόγιο"
            >
              <CalendarBlank size={16} className="opacity-70" />
            </Button>
          </PopoverTrigger>
        </div>
      </PopoverAnchor>
      <PopoverContent className="w-auto p-0" align="start" side="bottom" sideOffset={4}>
        <Calendar
          mode="single"
          locale={el}
          selected={selected}
          defaultMonth={selected}
          onSelect={(d) => { onChange(d ? format(d, "yyyy-MM-dd") : ""); setOpen(false); }}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
